import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer 
      data-testid="footer-container"
      className="relative z-10 border-t border-white/5 py-16"
    >
      {/* Elegant Glowing gradient divider top line as specified in guidelines */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[1px] bg-gradient-to-r from-transparent via-[#65FFB6]/40 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Brand */}
        <div className="flex items-center">
          <img
            src="/logo-clean.png"
            alt="NovaCore Staffing"
            data-testid="footer-logo-img"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </div>

        {/* Navigation Info Links */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-8 font-manrope text-xs text-slate-400 font-semibold uppercase tracking-wider">
          <Link to="/" data-testid="footer-home-link" className="hover:text-[#65FFB6] transition-colors">Home</Link>
          <Link to="/careers" data-testid="footer-careers-link" className="hover:text-[#65FFB6] transition-colors">Careers</Link>
          <Link to="/#industries" data-testid="footer-industries-link" className="hover:text-[#65FFB6] transition-colors">Industries</Link>
          <Link to="/#contact" data-testid="footer-contact-link" className="hover:text-[#65FFB6] transition-colors">Hire Talent</Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[#65FFB6] transition-colors"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[#65FFB6] transition-colors"
          >
            Privacy Policy
          </Link>
        </div>

        {/* Copyright */}
        <p className="text-[11px] font-mono text-slate-500 uppercase tracking-widest">
          © {new Date().getFullYear()} NOVACORE STAFFING. ALL ENCRYPTION PIPELINES SECURED.
        </p>
      </div>
    </footer>
  );
};
